// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3E0Xe","alert":"SettungsInbox_alert__1P7hU"};